import { render, staticRenderFns } from "./AddCompanyNews.vue?vue&type=template&id=212d4a12&scoped=true"
import script from "./AddCompanyNews.vue?vue&type=script&lang=js"
export * from "./AddCompanyNews.vue?vue&type=script&lang=js"
import style0 from "./AddCompanyNews.vue?vue&type=style&index=0&id=212d4a12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d4a12",
  null
  
)

export default component.exports